"use client";

import { createContext, use, type ReactNode } from "react";

const PageScrollContext = createContext(false);

export function RecordScrollBoundary({ children }: { children: ReactNode }) {
  return <PageScrollContext value>{children}</PageScrollContext>;
}

export function useRecordPageFill(requested: boolean | undefined): boolean {
  const pageOwnsScroll = use(PageScrollContext);
  return requested ?? !pageOwnsScroll;
}
